/** Types for the passkey endpoints on /auth/webauthn. */

/** A registered passkey as the API exposes it. */
export interface WebauthnCredential {
	_id: string
	name: string
	rpId: string
	deviceType: 'singleDevice' | 'multiDevice'
	backedUp: boolean
	createdAt: string
	lastUsedAt: string | null
}

/** Reply from the two options endpoints. */
export interface WebauthnOptionsResponse<T> {
	challengeId: string
	options: T
}

/** Error codes the passkey endpoints return in error.code. */
export enum WebauthnErrorCodes {
	WEBAUTHN_ONLY = 'webauthn_only',
	ORIGIN_INVALID = 'origin_invalid',
	CHALLENGE_INVALID = 'challenge_invalid',
	CREDENTIAL_UNKNOWN = 'credential_unknown',
	VERIFICATION_FAILED = 'verification_failed',
	USER_VERIFICATION_REQUIRED = 'user_verification_required',
	LAST_CREDENTIAL = 'last_credential',
	ENROLL_TOKEN_INVALID = 'enroll_token_invalid'
}
